import { render, staticRenderFns } from "./CircleCounter.vue?vue&type=template&id=65bc71c8&scoped=true&"
import script from "./CircleCounter.vue?vue&type=script&lang=js&"
export * from "./CircleCounter.vue?vue&type=script&lang=js&"
import style0 from "./CircleCounter.vue?vue&type=style&index=0&id=65bc71c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bc71c8",
  null
  
)

export default component.exports